import { Tooltip } from '@redislabsdev/redis-ui-components';
import { InfoIcon } from '@redislabsdev/redis-ui-icons';
import { useTheme } from 'styled-components/macro';
import { HoverAbleInfoIconProps } from './HoverableInfoIcon.types';
import * as S from './HoverableInfoIcon.style';

const HoverableInfoIcon = ({
  tooltipContent,
  tooltipMaxWidth,
  size = 'L',
  iconDataTestId
}: HoverAbleInfoIconProps) => {
  return (
    <Tooltip
      maxWidth={tooltipMaxWidth}
      content={tooltipContent}
      interactive={typeof tooltipContent !== 'string'}
    >
      <S.Wrapper {...(iconDataTestId && { 'data-testid': iconDataTestId })}>
        <InfoIcon size={size} customColor={useTheme().components.label.infoIcon.iconColor} />
      </S.Wrapper>
    </Tooltip>
  );
};

export default HoverableInfoIcon;
